import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll ke atas saat route berubah
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth' // Gunakan 'auto' jika ingin scroll instan
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;